import React, { useState } from "react";
import { Button, Menu, MenuItem, CircularProgress } from "@mui/material";
import { Upload } from "lucide-react";

const ExcelButton = ({ isExportingMain, isExportingSecondary, handleExportMain, primaryExcel, handleExportSecondary, secondaryExcel, isSecondaryExcel }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return isSecondaryExcel ? (
    <>
      <div className="btn buttons-collection btn-success btn-sm dropdown-toggle" variant="outlined" size="small" onClick={handleClick}>
        <Upload size={16} />
        <span className="px-1"> Export to Excel</span>
      </div>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleExportMain();
            handleClose();
          }}
          disabled={isExportingMain}
        >
          {isExportingMain ? <CircularProgress size={16} /> : `Export ${primaryExcel}`}
        </MenuItem>

        {secondaryExcel && (
          <MenuItem
            onClick={() => {
              handleExportSecondary();
              handleClose();
            }}
            disabled={isExportingSecondary}
            sx={{ color: "secondary.main" }}
          >
            {isExportingSecondary ? <CircularProgress size={16} /> : `Export ${secondaryExcel}`}
          </MenuItem>
        )}
      </Menu>
    </>
  ) : (
    <>
      <button
        className="btn buttons-collection  btn-success btn-sm dropdown-toggle"
        tabIndex={0}
        aria-controls="DataTables_Table_0"
        type="button"
        aria-haspopup="dialog"
        aria-expanded="false"
      >
        <span>
          <span onClick={handleExportMain} disabled={isExportingMain} className="d-flex align-items-center gap-2">
            <i className="icon-base ti tabler-upload icon-xs" />
            <span className="d-none d-sm-inline-block">
              {isExportingMain ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" role="status" />
                  Exporting...
                </>
              ) : (
                "Export to Excel"
              )}
            </span>
          </span>
        </span>
      </button>
    </>
  );
};

export default ExcelButton;
